import React from 'react';
import styled from 'styled-components';
import Toaster from '../toaster/toaster';
import useNotifications from '../../hooks/useNotifications/useNotifications';

function Notifications() {
  const { notifications, removeNotification } = useNotifications();

  return (
    <Wrapper>
      <NotificationList>
        {
          notifications && notifications.map(
            (notification, index) => (
              <Toaster
                key={`notification-${index}`}
                onClear={() => removeNotification(index)}
                {...notification}
              />
            ),
          )
        }
      </NotificationList>
    </Wrapper>
  );
}

const NotificationList = styled.ul`
  position: fixed;
  z-index: 2;
  margin: 0;
  ${({ theme }) => theme.media.tablet} {
    width: 60%;
  }
  ${({ theme }) => `
    right: ${theme.toaster.right};
    bottom: ${theme.toaster.bottom};
    ${theme.media.tablet} {
      inset: 60px 5px auto;
      width: auto;
      max-width: 100%;
      padding-left: 0px;
    }
  `}
`;

const Wrapper = styled.div`
  position: relative;
  z-index: 2;
  right: 0;
  bottom: 0;
  margin: 0;
`;

export default Notifications;
